module.exports={
  "GOP": 29,
  "Dem": 34,
  "Other": 2,
  "house_GOP": 0,
  "house_Dem": 0,
  "house_Other": 0
}